// HEADER SCROLLED
document.addEventListener('DOMContentLoaded', function() {
  const headerEle = document.querySelector('.c-header');
  window.addEventListener('scroll', function(e) {
    headerEle.classList[this.scrollY > 50 ? 'add' : 'remove']('scrolled');
  });

  // check current position
  if(window.scrollY > 50){
    headerEle.classList.add('scrolled');
  }
});